import { CookieSetOptions } from "universal-cookie";

// secure=true won't work on non-secure domains except localhost
const isLocalOrSSH =
  location.protocol === "https:" || location.hostname === "localhost";

export const defaultCookieOptions: CookieSetOptions = {
  path: "/",
  sameSite: isLocalOrSSH ? "none" : undefined,
  secure: isLocalOrSSH ? true : undefined,
};
